import ThemedSelect from "./ThemedSelect.jsx";
import { Form, InputGroup } from "react-bootstrap";

// The legacy DropdownTextbox, modernised: a picker dropdown + a free-text field.
// Selecting an option COPIES its text into the field (then resets the picker), and
// the field stays fully editable — the TEXT is what saves, never an id. Options
// come grouped (optgroups replace legacy's blank-row separators).
//
//   <DropdownText name="to_party" value={form.to_party} onChange={handleText}
//                 groups={[{ label: "Team", options: ["Karen", …] }, …]} />

function DropdownText({ name, value, onChange, groups = [], placeholder, size = "sm", className = "" }) {
  function pick(e) {
    const picked = e.target.value;
    if (!picked) return;
    onChange({ target: { name, value: picked } });
    e.target.value = ""; // the picker is a one-shot populate, not a state holder
  }

  return (
    <InputGroup size={size} className={className}>
      <ThemedSelect
        className="cd-select-suggestions"
        size={size}
        defaultValue=""
        menuMinWidth={340}
        maxMenuHeight={480}
        compactMenu
        hideSelectedOptions
        onChange={pick}
        // The themed wrapper is a div: InputGroup otherwise shrinks it to 1%.
        style={{ width: 46, flex: "0 0 46px" }}
        data-hint="Pick from quick entries, team or companies. Scroll or type to search; the text stays editable."
        aria-label={`${placeholder || name} suggestions`}
      >
        <option value=""></option>
        {groups
          .filter((g) => g.options.length > 0)
          .map((g) => (
            <optgroup key={g.label} label={`${g.label} (${g.options.length})`}>
              {g.options.map((o) => (
                <option key={`${g.label}:${o}`} value={o}>{o}</option>
              ))}
            </optgroup>
          ))}
      </ThemedSelect>
      <Form.Control
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={100}
      />
    </InputGroup>
  );
}

export default DropdownText;
